if (!customElements.get('smileat-team-member')) {
  class SmileatTeamMember extends HTMLElement {
    constructor() {
      super();
      this.pageSize = 8;
      this.tabs = this.querySelectorAll('.team-member__tab');
      this.panels = this.querySelectorAll('.team-member__panel');
      this.prevBtn = this.querySelector('.team-member__arrow--prev');
      this.nextBtn = this.querySelector('.team-member__arrow--next');

      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          this.activateTab(tab.dataset.tab);
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          const activePanel = this.querySelector('.team-member__panel.is-active');
          const page = parseInt(activePanel.dataset.page) || 0;
          if (page > 0) this.showPage(activePanel, page - 1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          const activePanel = this.querySelector('.team-member__panel.is-active');
          const page = parseInt(activePanel.dataset.page) || 0;
          const cards = activePanel.querySelectorAll('.team-member__card');
          const maxPage = Math.ceil(cards.length / this.pageSize) - 1;
          if (page < maxPage) this.showPage(activePanel, page + 1);
        });
      }

      // Initialize first tab
      const firstTab = this.querySelector('.team-member__tab.is-active') || this.tabs[0];
      if (firstTab) {
        this.activateTab(firstTab.dataset.tab);
      }
    }

    getPanel(id) {
      return this.querySelector(`.team-member__panel[data-panel="${id}"]`);
    }

    showPage(panel, page) {
      const isMobile = window.innerWidth < 749;
      const cards = panel.querySelectorAll('.team-member__card');
      const total = cards.length;
      const totalPages = Math.ceil(total / this.pageSize);
      panel.dataset.page = page;

      cards.forEach((card, i) => {
        if (isMobile) {
          card.style.display = 'flex';
        } else {
          const inPage = (i >= page * this.pageSize && i < (page + 1) * this.pageSize);
          card.style.display = inPage ? 'flex' : 'none';
        }
      });

      const needsArrows = total > this.pageSize && !isMobile;
      const pagination = this.querySelector('.team-member__pagination');
      if (pagination) {
        pagination.classList.toggle('is-hidden', !needsArrows);
      }

      if (this.prevBtn) {
        this.prevBtn.toggleAttribute('disabled', isMobile || page === 0);
        this.prevBtn.classList.toggle('is-disabled', isMobile || page === 0);
      }
      if (this.nextBtn) {
        this.nextBtn.toggleAttribute('disabled', isMobile || page >= totalPages - 1);
        this.nextBtn.classList.toggle('is-disabled', isMobile || page >= totalPages - 1);
      }
    }

    activateTab(id) {
      if (!id) return;
      
      this.tabs.forEach(t => {
        const isActive = t.dataset.tab === id;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive);
      });
      this.panels.forEach(p => {
        p.classList.toggle('is-active', p.dataset.panel === id);
      });
      
      const activePanel = this.getPanel(id);
      if (activePanel) {
        const grid = activePanel.querySelector('.team-member__grid');
        if (grid) grid.scrollLeft = 0;
        this.showPage(activePanel, 0);
      }
    }
  }

  customElements.define('smileat-team-member', SmileatTeamMember);
}
